import {CompetitorArticleMarketplace} from "../types/competitor-article-data.types";

export const competitorArticleMarketplaceIcon: Record<CompetitorArticleMarketplace, string> = {
  OZON: 'ozon-icon',
  WILDBERRIES: 'wildberries-icon'
};
